import { Injectable } from "@angular/core";
import { SearchResponse } from "../../../../objects/responses/searchResponse";
import { Seller } from "../../../../objects/amazon/seller";
import { AmazonService } from "../../../../services/amazon.service";
import { ActivatedRouteSnapshot } from "@angular/router";

@Injectable()
export class AmazonStoreResolver {
    constructor(private amazonService: AmazonService ) {
    }

    public resolve(route: ActivatedRouteSnapshot): Promise<SearchResponse<Seller>> {
        let sellerId = route.params["sellerId"];

        return this.amazonService.getSellerByUserId(sellerId).then(result => {
            return result.Data;
        }).catch(err => {
            return null;
        });
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/amazon-management/store/amazon-store.resolver.ts